/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const Wrapper = styled.div`
  margin-left: auto;
  margin-right: 11px;
`;
Wrapper.displayName = 'Wrapper';
